var _a, _b;
import { SplitButton } from './SplitButton';
import { Button } from './Button';
import { FillSpace } from './FillSpace';
import { Separator } from './Separator';
import { Text } from './Text';
import { TOOLBAR_GROUP_TYPE, TOOLBAR_ITEM_TYPE } from '../types';
export var ToolbarControls = (_a = {},
    _a[TOOLBAR_ITEM_TYPE.button] = Button,
    _a[TOOLBAR_ITEM_TYPE.fillSpace] = FillSpace,
    _a[TOOLBAR_ITEM_TYPE.separator] = Separator,
    _a[TOOLBAR_ITEM_TYPE.text] = Text,
    _a);
export var ToolbarControlsWithGroup = (_b = {},
    _b[TOOLBAR_GROUP_TYPE.splitButton] = SplitButton,
    _b);
//# sourceMappingURL=ToolbarControls.js.map